export default __webpack_public_path__ + "static/media/chevron-expand.2173481c.svg";